enum SoftPullStatus {
  None = 'None',
  Active = 'Active',
  Expired = 'Expired'
}

export default SoftPullStatus;
